import React, { useState, useEffect } from "react";
import { Button, Tooltip } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { usePurchasePlanModel } from "../purchasePlanModel";
import useNavModel from "@/model/navModel";
import { globalPrompt } from "@/components/message";
import { usePurchasePlanDetailsModel } from "./details/purchasePlanDetailsModel"
import useGlobalModel from "@/model/globalModel";
import { formatNum } from "@/utils/utils";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/VrmResoureAuthEnum";
import { disableExportMsg } from "@/utils/exportFile";
import { PurchaseTable } from "./PrintPurchaseTable";
import { OnGetGoodPrint } from "./onGetGoodPrint";
import { saveAs } from 'file-saver'
import moment from "moment";
import { purchasePlanService } from "../purchasePlanService";
const ExcelJS = require('exceljs')

export const DataBox = () => {
    const { selectedRowKeys, selectedRow, descTotal, rowsDescTotal, exportPurchasePlan, exportPurchasePlanDetail, setPrint } = usePurchasePlanModel();
    const { setDetailEditForm, setDetailDataSource } = usePurchasePlanDetailsModel();
    const { selectedNavId, addNav, findNav, selectNav, switchNavState, replaceNav } = useNavModel();
    const [visible, setVisible] = useState(false);
    const [printVisible, setPrintVisible] = useState<boolean>(false);
    const [onGetGoodPrintVisible, setOnGetGoodPrintVisible] = useState<boolean>(false);
    const { shopAndOrg: { shopCode, shopName: Name } } = useGlobalModel()
    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let supplierEditKey = "11-1-2";
        let isFindNav = findNav(supplierEditKey);
        if (!isFindNav) {
            addNav(supplierEditKey, { id: selectedRow.planCode as string, mode: "edit" });
        } else {
            globalPrompt("modal", {
                title: "采购订单跳转详情",
                type: "warning",
                text: "您还有采购订单详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(supplierEditKey, { id: selectedRow.planCode as string, mode: "edit" });
                    // updateEditFormVal(null);
                    setDetailEditForm({})
                    setDetailDataSource([])
                }
            })
        }
    }
    const desc: IDescription[] = [
        {
            label: "计划总量",
            value: selectedRowKeys.length === 0 ? descTotal.totalNum : rowsDescTotal.totalNum,
            color: DescriptionColorEnum.red
        },
        {
            label: "计划总金额",
            value: formatNum(selectedRowKeys.length === 0 ? descTotal.totalAmount : rowsDescTotal.totalAmount),
            color: DescriptionColorEnum.red
        }
    ]
    const onLook = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let supplierEditKey = "11-1-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: selectedRow.planCode as string, mode: "look", },
            true
        );

    }
    const onPrint = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        setPrintVisible(true)
    }
    const onGetGoodPrint = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        setOnGetGoodPrintVisible(true)
    }
    const exportExcel = () => {
        if (selectedRowKeys.length === 0) {
            globalPrompt("message", { text: "请选择数据进行打印！", type: "warning" });
            return;
        }
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行打印！", type: "warning" });
            return;
        }
        purchasePlanService.one(selectedRow.planCode as string).then((res: any) => {
            if (res.retData) {
                let { details, ...formVal } = res.retData;
                let listData = details.filter((item: any) => item.deleteFlag !== 1);
                let form = formVal

                // 创建一个新的工作簿
                const workbook = new ExcelJS.Workbook();
                // 添加一个工作表
                const worksheet = workbook.addWorksheet("导入数据明细", { properties: { tabColor: { argb: 'FFC0000' } } }); // 创
                // 设置标题
                worksheet.mergeCells('A1:I1'); // 合并A1到L1的单元格
                const title = worksheet.getCell('A1');
                title.value = `${Name}汽车配件采购项目送货单`;
                title.alignment = { vertical: 'middle', horizontal: 'center' }; // 设置标题居中对齐
                title.font = { name: "FangSong", family: 4, size: 16, bold: true }; // 字体

                // 采购批次
                worksheet.mergeCells('A2:D2'); // 合并A1到L1的单元格
                const batchCode = worksheet.getCell('A2');
                batchCode.value = `采购批次：${form.batchCode ?? ""}`;
                batchCode.alignment = { vertical: 'middle', horizontal: 'left' }; // 设置标题居中对齐
                batchCode.font = { name: "FangSong", family: 4, size: 12, bold: true }; // 字体

                // 设置制表时间
                worksheet.mergeCells('E2:I2'); // 合并A1到L1的单元格
                const newTime = worksheet.getCell('E2');
                newTime.value = `送货时间：${moment(new Date()).format('YYYY-MM-DD HH:mm:ss')}`;
                newTime.alignment = { vertical: 'middle', horizontal: 'right' }; // 设置标题居中对齐
                newTime.font = { name: "FangSong", family: 4, size: 12, bold: true }; // 字体

                // 设置表头
                const headers = ['序号', '配件编码', '产品名称', '品牌', '车型', '型号', '单位', '数量', '备注'];
                const headersEN = ['materialCode', 'materialName', 'brandName', 'vehicleModel', 'model', 'unitName', 'planNum', 'note'];
                for (let i = 0; i < headers.length; i++) {
                    const cell = worksheet.getCell(3, i + 1); // 第三行开始，从第一列开始
                    cell.value = headers[i];
                    cell.alignment = { vertical: 'middle', horizontal: 'center' }; // 设置表头居中对齐
                    cell.font = { name: "FangSong", family: 4, size: 11, bold: true }; // 字体
                    cell.border = { top: { style: 'medium' }, bottom: { style: 'medium' }, left: { style: 'medium' }, right: { style: 'medium' } }; // 设置边框
                }

                // 填充表格内容
                const data = listData.map((item: any, index: any) => {
                    let arr: any = [index + 1]
                    headersEN.forEach((dataIndex) => {
                        let val = item[dataIndex]
                        arr.push(val)
                    })
                    return arr.slice(0, 9)
                })

                for (let i = 0; i < data.length; i++) {
                    for (let j = 0; j < data[i].length; j++) {
                        const cell = worksheet.getCell(i + 4, j + 1); // 从第四行开始填充数据
                        cell.value = data[i][j];
                        cell.alignment = { vertical: 'middle', horizontal: 'center' }; // 设置内容居中对齐
                        cell.font = { name: "FangSong", family: 4, size: 11, bold: true }; // 字体
                        cell.border = { top: { style: 'medium' }, bottom: { style: 'medium' }, left: { style: 'medium' }, right: { style: 'medium' } }; // 设置边框
                    }
                }

                // 送货人
                worksheet.mergeCells(`A${data.length + 5}:E${data.length + 5}`); // 合并A1到L1的单元格
                const contact = worksheet.getCell(`A${data.length + 5}`);
                contact.value = `送货人:${form.contact ?? ""}`;
                contact.alignment = { vertical: 'middle', horizontal: 'left' }; // 设置标题居中对齐
                contact.font = { name: "FangSong", family: 4, size: 12, bold: true }; // 字体

                // 接收人
                worksheet.mergeCells(`F${data.length + 5}:I${data.length + 5}`); // 合并A1到L1的单元格
                const getUser = worksheet.getCell(`F${data.length + 5}`);
                getUser.value = `接收人:`;
                getUser.alignment = { vertical: 'middle', horizontal: 'left' }; // 设置标题居中对齐
                getUser.font = { name: "FangSong", family: 4, size: 12, bold: true }; // 字体

                // 送货公司
                worksheet.mergeCells(`A${data.length + 6}:E${data.length + 6}`); // 合并A1到L1的单元格
                const supplierName = worksheet.getCell(`A${data.length + 6}`);
                supplierName.value = `送货公司:${form.supplierName ?? ""}`;
                supplierName.alignment = { vertical: 'middle', horizontal: 'left' }; // 设置标题居中对齐
                supplierName.font = { name: "FangSong", family: 4, size: 12, bold: true }; // 字体

                // 接收站点
                worksheet.mergeCells(`F${data.length + 6}:I${data.length + 6}`); // 合并A1到L1的单元格
                const shopName = worksheet.getCell(`F${data.length + 6}`);
                shopName.value = `接收站点:${form.shopName ?? ""}`;
                shopName.alignment = { vertical: 'middle', horizontal: 'left' }; // 设置标题居中对齐
                shopName.font = { name: "FangSong", family: 4, size: 12, bold: true }; // 字体

                // 导出文件
                workbook.xlsx.writeBuffer().then((buffer: any) => {
                    let blob = new Blob([buffer], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    })
                    saveAs(blob, '送货单打印.xlsx')
                })
            }
        });
    }
    const action = <>
        <YhAuth resCode={ResourceAuthEnum.P_PL_AD}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => addNav("11-1-1", { id: "", mode: "add" })}
            >新增</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_PL_ED}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onEdit}
            >编辑</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_PL_VW}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={onLook}
            >查看</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_PL_EX}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => { exportPurchasePlan().then() }}
            >导出</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_PL_EX}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => { exportPurchasePlanDetail().then() }}
            >明细导出</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_PL_PRINT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => onPrint()}
            >打印</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_PL_GETG00DPRINT}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => onGetGoodPrint()}
            >单据打印</Button>
        </YhAuth>
        <YhAuth resCode={ResourceAuthEnum.P_PL_EXEXCEL}>
            <Button
                className="mr-5"
                type="primary"
                shape="round"
                onClick={() => exportExcel()}
            >导出excel</Button>
        </YhAuth>
    </>;

    return (
        <>
            {/* <YhBox title={"采购订单列表"} descriptions={desc} action={action} style={{height:'calc(100vh - 200px)'}}> */}
            <YhBox action={action} style={{ height: 'calc(100vh - 180px)' }}>
                <DataTable />
            </YhBox>
            <PurchaseTable printVisible={printVisible} setPrintVisible={setPrintVisible} />
            <OnGetGoodPrint onGetGoodPrintVisible={onGetGoodPrintVisible} setOnGetGoodPrintVisible={setOnGetGoodPrintVisible} />
        </>
    )
}